import React from 'react';
import { Button, Badge, Checkbox } from 'components/lib';
import Style from './table.module.scss';

export function Body(props){

  if (props.data?.length){
    return (
      <tbody>
        { props.data.map((row, index) => {
          
          return <Row {...props } data={ row } key={ index } rowNum={index+1} detail={props.detail}/>

        })}
      </tbody>
    );
  }

  return (
    <tbody>
      <tr>
        <td colSpan='10'>No results found</td>
      </tr>
    </tbody>
  );
}

export function Row(props){

  let row = {...props.data }
  row.actions = row.actions || props.actions;
  const hasActions = Object.values(row.actions).some(x => (x !== undefined));
    return(
      <>
    <tr data-id={ props.data.id }>

      { 
       props.showRowNumbers &&
        <td>{props.rowNum}</td>
      }

      { 
      row.actions?.selectRecord &&
        <td>
          {/* <Button key={ props.data.id } icon={ props.data.checked == true ? 'eye' : 'mail' } action={ () => row.actions?.selectRecord(props.data.id) } /> */}
          <Checkbox checked={props.data.checked} id={props.data.id} callback={() => row.actions?.selectRecord(props.data.id)} />
          </td>
      }

      {Object.keys(row).map((cell, index) => {
        
        // actions
        if (cell === 'actions'){
          if (hasActions){
            return (
              <td key={ index } className={ Style.actions }>

                { row.actions?.custom?.map((action, i) => {
                  if (action.condition){

                    return row[action.condition.col] === action.condition.value ? 
                      <Button key={ i } icon={ action.icon } action={ () => action.action(row) } /> : false;

                  }

                  return <Button key={ i } icon={ action.icon } action={ () => action.action(row) } />

                })}
                
                { row.actions.edit &&
                  <Button icon='edit' action={ () => row.actions.edit(row, (res) => props.callback.edit(res, row) )}/>}

                { row.actions.download &&
                  <Button icon='download' url={ row.actions.download }/>}

                { row.actions.view &&
                  <Button icon='eye' url={ `${row.actions.view.url}/${row[row.actions.view.col]}` }/>}

                { row.actions.email &&
                  <Button icon='mail' action={ () => window.location = `mailto:${row.email}` }/>}

                { row.actions.invite &&
                  <Button icon='mail' action={ e => row.actions.invite(row) }/> }
                                   
                { row.actions.delete &&
                  <Button icon='trash' action={ () => row.actions.delete(row, (res) => props.callback.delete(res, row)) }/>}
                  
              </td>
            );
          }
          else return false;

        }

        // hide
        if (props.hide?.includes(cell))
          return false;

        // show
        if (props.show && !props.show.includes(cell))
          return false;

        let value = row[cell];

        // is date/time
        if (/([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))/.test(value)){
          const date = new Date(value).toLocaleDateString();
          const time = new Date(value).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
          value = `${date} ${time}`;
          return (
            <td key={ index } style={{ whiteSpace: 'nowrap' }}>
              { value }
            </td>
          );
        }

        // has hyperlink
        if (value !== undefined && props.hyperlink && Array.isArray(props.hyperlink)) {
          const hyperlink = props.hyperlink.find(link => link.col === cell);
          if (hyperlink) {
            return (
              <td key={ index }>
                {hyperlink.url !== undefined && hyperlink.url !== null && hyperlink.url !== '' ?
                <a href={hyperlink.url} style={{color: '#707070', textDecoration: 'underline'}} className={Style.hyperlink}>{value}</a> 
                : 
                hyperlink.callback !== undefined && hyperlink.callback !== null && hyperlink.callback !== '' ?
                <button style={{color: '#707070', textDecoration: 'underline'}} className={Style.hyperlink} onClick={() => hyperlink.callback(row, (res) => props.callback.hyperlink(res, row))}>
                  {value}
                </button>
                :
                <button style={{color: '#707070', textDecoration: 'underline'}} className={Style.hyperlink} onClick={() => row.actions.hyperlink(row, (res) => props.callback.hyperlink(res, row))}>
                  {value}
                </button>
              }
              </td>
            );
          }
        }

        // has badge
        if (value !== undefined && props.badge && cell === props.badge.col){

          // default color
          let color = props.badge.color;

          // check each condition
          if (props.badge.condition){
            props.badge.condition.forEach(cond => {

              (typeof cond.value === 'string' && typeof value === 'string') ? 
                color = cond.value.toLowerCase() === value.toLowerCase() ? cond.color : color :
                color = cond.value === value ? cond.color : color;

            });
          } 
   
          return (
            <td key={ index }>
              <Badge text={ value === true  ? 'Yes' : (value === false ? 'No' : value) } color={ color }/>
            </td>
          );
        }

        // render image if value ends with a common image file extension
        if (typeof value === 'string' && /\.(jpg|jpeg|png|gif|svg)$/.test(value)) {
          return (
            <td key={ index }>
              <img src={value} alt="icon" style={{ height: 24, width: 24 }} />
            </td>
          );
        }

        // handle object with value and display properties (for custom sorting)
        if (typeof value === 'object' && value !== null && 'display' in value) {
          return (
            <td key={ index }>
              { value.display }
            </td>
          );
        }

        // standard cell
        return(
          <td key={ index }>
            { value === true  ? 'Yes' : (value === false ? 'No' : value) }
          </td>
        );
      })}

      
    </tr>
    { props.data.checked && props.detail &&
      <tr>
        <td colSpan={'100%'}>
        {props.detail()}
        </td>
      </tr>
    }
    </>
  );
}
